var navigation = {"app-header":"_app-header_3li5l_25 _page-content_msqww_1","appHeader":"_app-header_3li5l_25 _page-content_msqww_1"};

export { navigation as default };
